module.exports = __webpack_public_path__ + "img/nxs.cfb414e0.svg";